import ChildCareIcon from '@mui/icons-material/ChildCare';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import AssignmentIcon from '@mui/icons-material/Assignment';
import GavelIcon from '@mui/icons-material/Gavel';
import SchoolIcon from '@mui/icons-material/School';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import CasinoIcon from '@mui/icons-material/Casino';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import NatureIcon from '@mui/icons-material/Nature';
import ConstructionIcon from '@mui/icons-material/Construction';
import StorefrontIcon from '@mui/icons-material/Storefront';
import BadgeIcon from '@mui/icons-material/Badge';
import BusinessIcon from '@mui/icons-material/Business';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CancelIcon from '@mui/icons-material/Cancel';

export const iconMap = {
  ChildCareIcon,
  FavoriteIcon,
  PersonOutlineIcon,
  FamilyRestroomIcon,
  AssignmentIcon,
  GavelIcon,
  SchoolIcon,
  LocalHospitalIcon,
  CasinoIcon,
  RocketLaunchIcon,
  NatureIcon,
  ConstructionIcon,
  StorefrontIcon,
  BadgeIcon,
  BusinessIcon,
  AppRegistrationIcon,
  CancelIcon
};
